import { render, staticRenderFns } from "./UploadAbsensiSertifikasi.vue?vue&type=template&id=5630dc5a&"
import script from "./UploadAbsensiSertifikasi.vue?vue&type=script&lang=js&"
export * from "./UploadAbsensiSertifikasi.vue?vue&type=script&lang=js&"
import style0 from "./UploadAbsensiSertifikasi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports